module.exports = __webpack_public_path__ + "media/images/icons/payment_methods/GooglePay-62cc893a3f8e744cd7bd2a9cd6680be6.svg";